import { render } from "./work_report.vue?vue&type=template&id=24c8ea0c"
import script from "./work_report.vue?vue&type=script&lang=js"
export * from "./work_report.vue?vue&type=script&lang=js"

import "./work_report.vue?vue&type=style&index=0&id=24c8ea0c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__